<template>
    <div class="canvas-header">
        <div class="left">
            <img src="/images/dfc-logo.svg" class="logo" alt="">
            <div class="team">
                <div class="name"><strong>Team</strong>: {{ team.name }}</div>
                <div class="students">
                    <div v-for="student in students" :key="student.id" class="student">
                        <name-icon :value="student"
                                   :show-name="false"
                                   :editable="false"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="center">
            <div class="title">
                <h1>Actvities</h1>
            </div>
        </div>
        <div class="right">
            <div class="menu">
                <button class="btn btn-light">
                    <icon-menu :size="24" color="dark" />
                </button>

                <div class="canvas-map">

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import NameIcon from "@/Components/Team/NameIcon";
import IconVolumeMedium from "@/Icons/IconVolumeMedium";
import IconMenu from "@/Icons/IconMenu";
export default {
    name: "CanvasHeader",
    components: {IconMenu, IconVolumeMedium, NameIcon},
    props: {
        title: {
            type: String,
        },
        team: {
            type: Object,
        }
    },

    computed: {
        students(){
            return this.team.members.slice().reverse();
        }
    }

}
</script>

<style lang="scss" scoped>
.canvas-header{
    display: flex;
    padding: .6rem;
    align-items: center;
}

.left, .right{
    display: flex;
    flex: 0 0 35%;
    width: 35%;
}

.center{
    flex: 0 0 30%;
    width: 30%;
}

.logo{
    width: 100%;
    max-width: 80px;
}

.title{
    text-align: center;

    h1{
        font-size: 2rem;
        font-weight: $font-weight-bold;
    }
}

.team{
    display: flex;
    align-items: center;
    padding: 0 1rem;

    .name{
        font-size: 1.1rem;
        margin-right: 0.3rem;
    }
}

.students{
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
}

.student{
    margin-left: -0.6rem;

    &:last-child{
        margin-left: 0;
    }
}

.menu{
    margin-left: auto;
    margin-right: 0;
}

.btn{
    background: none;
    border: none;
}

</style>
